import React, { Fragment, useMemo } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { RenderModalWrapperProps } from '../../../common/types/commands/index.tsx';
import { getActiveCommandList } from '../../../common/utils/get-active-command-list/index.tsx';
import { useCommandPaletteExpandedCommand } from '../../../controllers/command-palette/index.tsx';

export const ModalWrapper = ({ children }: RenderModalWrapperProps): React.JSX.Element => {
	const [{ expandedCommand }] = useCommandPaletteExpandedCommand();

	const Wrapper = useMemo(
		() =>
			getActiveCommandList(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components
				?.Wrapper || Fragment,
		[expandedCommand],
	);

	return (
		<Wrapper>
			<ModalDialogWrapper>{children}</ModalDialogWrapper>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ModalDialogWrapper = styled.div({
	marginTop: token('space.negative.050'),
	marginRight: token('space.negative.050'),
	marginBottom: token('space.negative.050'),
	marginLeft: token('space.negative.050'),
	borderRadius: '1rem',

	backgroundColor: token('elevation.surface.overlay'),
	boxShadow: token('elevation.shadow.overlay'),
});
